import { ClientUser } from '@weblite/ts-action/client-user'
import { dataProfileGet, dataProfileSet } from '@weblite/action/profile'
import { t } from '$i18n'
import { wsReq } from '$setup/ws'
import { createHall } from '$logic/hall'
import { getUserDisplayName } from '$logic/users'
import { updateTwaPermissions } from '$logic/twaCommunication'
import { TEACHER_PLAYGROUND_CHANNEL_TAG } from '$logic/hall/constant'
import { Location, Profile, UserRole } from '$logic/profile/types'
import { profileStorage } from './storage'

export const ACCEPTABLE_STUDENT_VERSION = 4
export const ACCEPTABLE_TEACHER_VERSION = 5

export function getProfile(): Profile | null {
  const profile = profileStorage.get()
  if (profile) return profile

  // TODO: Return default value
  return null
}

export function getReadableLocation(location?: Partial<Location>) {
  if (location && location.province && location.county)
    return `${location.province}، ${location.county}`
  return ''
}

function setProfileGAEvent() {
  if (!window.gtag) return

  const profile = getProfile() as Profile

  if (profile?.school?.role) {
    window.gtag('set', 'user_properties', { role: profile.school.role })
  }
}

export async function createProfile(profile: Profile, clientUser?: ClientUser) {
  await editProfile(profile)
  if (clientUser && profile.school?.role === UserRole.TEACHER) {
    createTeacherPlaygroundChannel(getUserDisplayName(clientUser))
  }
}

export async function editProfile(profile: Profile) {
  wsReq(dataProfileSet({ data: profile }))
  // if (res.error) {
  // TODO handle UI
  // throw res.error.message
  // }

  await profileStorage.set(profile)
  setProfileGAEvent()
}

export const getUserProfile = async () => {
  const { payload } = await wsReq(dataProfileGet({}))
  return payload.data as Profile
}

export const syncUserProfile = async () => {
  const profile = await getUserProfile()
  await profileStorage.set(profile)
  setProfileGAEvent()
  updateTwaPermissions()
}

export async function createTeacherPlaygroundChannel(
  teacherFullName: string,
  tags?: string[],
) {
  const channelName = t('channel.teacherTestChannelName')(teacherFullName)

  return createHall({
    name: channelName,
    type: 'CHANNEL',
    description: '',
    image: '',
    tags: [TEACHER_PLAYGROUND_CHANNEL_TAG, ...(tags || [])],
  })
}
